import {
  Icon,
  IconColor,
  IconName,
  IconSize,
  TipPlacement,
  Tooltip
} from '@focaldata/cin-ui-components'
import { FC } from 'react'

/**
 * Read-only marker shown on a conjoint attribute value's row when it is
 * restricted to a subset of packages, so the restriction is visible while
 * authoring without having to open the dialog. Not clickable — editing happens
 * in PackageRestrictionsDialog, opened from the button next to ConjointSettings.
 */
const PackageRestrictionsIndicatorIcon: FC = () => (
  <Tooltip
    title="Restricted to specific packages"
    tipPlacement={TipPlacement.Top}
  >
    <span data-testid="package-restrictions-indicator">
      <Icon
        name={IconName.FilterAltOutlined}
        size={IconSize.Medium}
        iconColor={IconColor.Background}
      />
    </span>
  </Tooltip>
)

export default PackageRestrictionsIndicatorIcon
